import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  Label,
  Line,
  ReferenceLine,
} from "recharts";
import { DateTickEvery3rdTickWithVerticalDividersBar } from "../RechartHelpers/DateTickEveryXTicksWithVerticalDividersBar";
import RotatedYAxisLabel from "../RechartHelpers/RotatedYAxisLabel";
import RotatedYAxisLabelRight from "../RechartHelpers/RotatedYAxisLabelRight";
import BarLabelWithNullZeros from "../RechartHelpers/BarLabelWithNullZeros";
import { ChartStyles } from "../../../pages/customers/pci/Styles/PciChartStyles";

import LineDotWithNullZero from "../RechartHelpers/LineDotWithNullZero";
import {
  shiftNumberToLongForm,
  shiftNumberToWord,
} from "../RechartHelpers/ShiftNumberTranslator";

export default function BiAxialMultiShiftBarChart({
  title,
  data,
  xLabel,
  yLabel,
  y2Label,
  bars,
  lines,
  width = 1000,
  height = 600,
  useGrid = false,
  legend,
  line1References,
  line2References,
}) {
  return (
    <ChartStyles>
      <div className="chartBody">
        <p className="chartTitle">{title}</p>
        <ComposedChart
          width={width * 0.95}
          height={height}
          data={data}
          margin={{
            top: 30,
            right: 0,
            left: 5,
            bottom: 30,
          }}
          stackOffset="sign"
        >
          {useGrid ? <CartesianGrid strokeDasharray="3 3" /> : null}
          <XAxis dataKey="shift" tickFormatter={shiftNumberToLongForm}>
            <Label value={xLabel} offset={10} position="bottom" />
          </XAxis>
          <XAxis
            dataKey="date"
            tick={DateTickEvery3rdTickWithVerticalDividersBar({})}
            axisLine={false}
            tickLine={false}
            interval={0}
            xAxisId="dateId"
            scale="auto"
            type="category"
          />

          <YAxis
            type="number"
            orientation="left"
            yAxisId={"left"}
            label={<RotatedYAxisLabel height={height} value={yLabel} />}
          />
          <YAxis type="number" orientation="right" yAxisId={"right"}>
            <Label
              position="left"
              content={
                <RotatedYAxisLabelRight
                  height={height}
                  width={width * 0.93} // for some reason these values are all a mess -25 calibrates it more accurate to where it needs to be
                  value={y2Label}
                />
              }
            />
          </YAxis>

          {legend}

          <Tooltip labelFormatter={shiftNumberToWord} />

          {bars.map(({ key, name, stackId, fill, yAxisId, label }) => {
            return (
              <Bar
                key={key}
                dataKey={key}
                name={name}
                stackId={stackId}
                fill={fill}
                yAxisId={yAxisId}
                isAnimationActive={false}
              >
                {label ? (
                  <LabelList
                    key={key}
                    content={BarLabelWithNullZeros as any}
                    position="top"
                  />
                ) : null}
              </Bar>
            );
          })}

          {lines.map(
            ({
              key,
              name,
              yAxisId,
              fill,
              hasConnectingLine,
              textColor,
              strokeWidth,
            }) => {
              return (
                <Line
                  key={key}
                  dataKey={key}
                  name={name}
                  dot={LineDotWithNullZero(fill, textColor) as any}
                  stroke={fill}
                  strokeWidth={strokeWidth}
                  yAxisId={yAxisId}
                  isAnimationActive={false}
                  connectNulls={false}
                />
              );
            }
          )}

          {line1References.map(({ yValue, xValue, label }) => (
            <ReferenceLine
              key={label + Math.random()}
              y={yValue ? yValue : null}
              x={xValue ? xValue : null}
              yAxisId="left"
              ifOverflow="extendDomain"
            >
              <Label value={label} position={"insideRight"} />
            </ReferenceLine>
          ))}

          {line2References.map(({ yValue, xValue, label }) => (
            <ReferenceLine
              key={label}
              y={yValue ? yValue : null}
              x={xValue ? xValue : null}
              yAxisId="right"
              ifOverflow="extendDomain"
            >
              <Label value={label} position={"insideRight"} />
            </ReferenceLine>
          ))}
        </ComposedChart>
      </div>
    </ChartStyles>
  );
}
